module.exports = __webpack_public_path__ + "img/1516124750.b934ddc4.jpg";